import { DeliveriesRequiringAttentionHoverCard } from '../../../ui/components/pure/deliveries-requiring-attention/deliveries-requiring-attention-hover-card/deliveries-requiring-attention-hover-card.component';
import { NoteDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useQueryGetAccount } from '../../team/accounts.queries';
import dayjs from 'dayjs';
import { parseErrorMessage } from '../../../core/api/api.context';

export function NoteTooltip({ note }: { note: NoteDto }) {
  const heading = `${note.isPrivate ? 'Private' : 'Public'} note`;
  const content = `${note.content ?? ''}`;
  const { data, isLoading, error } = useQueryGetAccount(note.createdBy);
  const creatorName = `${data?.firstName} ${data?.lastName}`;
  const errorMessage = parseErrorMessage(error?.message!);
  const events = [
    {
      leftAlignedContent: `${creatorName} | ${dayjs(note.createdTime).format('DD MMM YYYY @ hh:mma')}`,
      rightAlignedContent: ''
    }
  ];

  return (
    <DeliveriesRequiringAttentionHoverCard
      isLoading={isLoading}
      heading={heading}
      title={content}
      events={events}
      error={errorMessage}
    ></DeliveriesRequiringAttentionHoverCard>
  );
}
